import { render, staticRenderFns } from "./HackathonPage.vue?vue&type=template&id=5795d376&scoped=true&"
import script from "./HackathonPage.vue?vue&type=script&lang=js&"
export * from "./HackathonPage.vue?vue&type=script&lang=js&"
import style0 from "./HackathonPage.vue?vue&type=style&index=0&id=5795d376&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795d376",
  null
  
)

export default component.exports